module.exports = __webpack_public_path__ + "img/微信图片_20251027135745_1191_62.6534316a.jpg";